<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <b-row class="no-gutters w-100">
        <b-col cols="12" md="6" class="my-1">
          <h1 class="mb-0 header-main text-uppercase d-inline">TEAM</h1>
        </b-col>
        <b-col cols="12" md="6" class="my-1">
          <div class="d-flex justify-content-end">
            <b-input-group class="">
              <b-form-input
                v-model="filter.search"
                placeholder="Search Team Name"
                @keydown.enter="handleSearch"
              />
              <b-input-group-append>
                <b-button @click="handleSearch" class="search-button">
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <button class="create-button ml-2" @click="handleCreate()">
              <font-awesome-icon icon="plus-square" />
              <span class="ml-2"> CREATE</span>
            </button>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        :empty-text="$t('noData')"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(name)="data">
          <div class="d-flex justify-content-center">
            {{ data.item.name }}
          </div>
        </template>
        <template v-slot:cell(totalAgent)="data">
          <div class="d-flex justify-content-center">
            {{
              parseInt(data.item.totalAgent) +
              parseInt(data.item.totalSupervisor)
            }}
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div class="d-flex justify-content-center">
            <div>
              <toggle-button
                :ref="`toggle-${data.item.roleMappingId}`"
                class="mt-1 mr-1"
                v-model="data.item.active"
                :color="{
                  checked: '#27BDA7',
                  unchecked: '#B0B0B0',
                }"
                @change="handleChangeStatus(data.item)"
              />
            </div>
          </div>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-center">
            <b-link class="text-link" @click="onEdit(data.item.roleMappingId)">
              <font-awesome-icon
                icon="pencil-alt"
                class="text-warning"
                title="Edit"
              />
            </b-link>
          </div>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="form-inline justify-content-center justify-content-sm-between"
        >
          <div v-if="rows > 0" class="my-auto">
            Showing {{ startPage | numeral("0,0") }} to
            {{ endPage | numeral("0,0") }} of
            {{ rows | numeral("0,0") }} entires
          </div>
          <div v-else class="my-auto">{{ rows || 0 }} entire</div>
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <ModalAlertConfirm
      :msg="$t('confirmDelete')"
      :text="modalMsgDelete"
      :btnConfirm="$t('delete')"
      colorBtnConfirm="danger"
      :btnCancel="$t('cancel')"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  name: "SettingTime",
  components: {
    ModalAlertConfirm,
    ModalAlertError,
  },
  data: function () {
    return {
      modalMsgDelete: "",
      bodyDelete: {
        id: 0,
      },
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      filter: {
        pageNo: 1,
        perPage: 10,
      },
      fields: [
        {
          key: "name",
          label: "Name",
          class: "w-100px",
          tdClass: "text-left",
        },
        {
          key: "totalAgent",
          label: "Total",
          class: "w-100px",
          tdClass: "text-left",
        },
        {
          key: "status",
          label: "Status",
          class: "w-100px",
          tdClass: "text-left",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      items: [],
    };
  },
  created: async function () {
    await this.pagination(1);
  },
  methods: {
    getList: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/Team/list/name`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.data;
            this.rows = data.detail.count;
          }
        });
      this.isBusy = false;
    },
    handleCreate() {
      this.$router.push({ path: `/team/create` }).catch(() => {});
    },
    onEdit(id) {
      this.$router.push({ path: `/team/${id}` }).catch(() => {});
    },
    onDeleteModal(data) {
      this.bodyDelete.id = data.id;
      this.modalMsgDelete = `${this.$t('confirmDelete2')} ${data.name} ${this.$t('yesOrNo')}`;
      this.$refs.ModalAlertConfirm.show();
    },
    async handleChangeStatus(item) {
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      let body = {
        roleMappingId: item.roleMappingId,
        active: item.active,
      };
      let index = this.items.findIndex(x => x.roleMappingId === item.roleMappingId);
      await this.axios
        .post(`${this.$baseUrl}/Team/detail/name/update-active`, body)
        .then(async (data) => {
          await this.$store.commit("UPDATE_MAIN_LOADING", false);
          if (data.result == 1) {
            this.$refs[`toggle-${item.roleMappingId}`].toggled = body.active;
            this.items[index].isActive = body.active;
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
          } else {
            this.$refs[`toggle-${item.roleMappingId}`].toggled = item.active;
            this.items[index].isActive = item.active;
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        });
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(`${this.$baseUrl}/apitrigger/${this.bodyDelete.id}`)
        .then(async (data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            await this.pagination(1);
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
      this.getShowingPage(Page);
    },
    async handleSearch() {
      this.pagination(1);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .input-group-append {
  height: 35px;
}

::v-deep .create-button {
  white-space: nowrap;
  height: 35px;
}
</style>
